// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --arc-purple: #632582;
    --header2-color: #04146a;
    --highlight-block-color: #5A729F;
    --border-blue: #add8e6;
    --contrast-blue: #ECF6FD;
    --filter-panel-grey: #F2F2F2;
    --arc-pink: #b40156;
    --anchor-visited: #632582;
    --filter-font-color: #605F5E;
    --arc-border-color: #c4c0c0;
    --arc-approved-color: #216C06;
    --arc-new-color: #6309e0;
    --arc-held-color: #f3a508;
    --arc-rejected-color: #8d0404;

    --wieldy-nav-background-color: #036 ;
    --wieldy-nav-highlight-orange: #fa8c16 ;
    --wieldy-nav-highlight-light-blue: #038fde ;

    --s360-orange: #ffe6cc;
    --s360-red: #ffcccc;
    --s360-yellow: #ffffcc;
    --s360-green: #d6f5d6;
    --s360-aqua: #e6ffff;
    --s360-blue: #99b9cd;
    --s360-purple: #f2ccff;
    --s360-pink: #ffe6ff;
    --s360-grey: #c7c7c7 ;
    --s360-black: #0a0a0a ;
    --s360-dialog-grey: #c7c7c7;

    --s360-icon-green: #4caf50 ;
    --s360-icon-gold: #ffcf40 ;
    --s360-icon-blue: #4c98c9 ;
    --s360-icon-red: #ad4f4f ;
    --s360-icon-orange: #FF9800 ;
    --s360-icon-pink: #d84bf3;
    --s360-icon-purple: #767db2;
    --s360-icon-unassigned: #d1d2d2 ;

    --s360-bgcolor: #e4ffdc ;
}
`, "",{"version":3,"sources":["webpack://./_devapp/_root.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,gCAAgC;IAChC,sBAAsB;IACtB,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;;IAE7B,oCAAoC;IACpC,uCAAuC;IACvC,2CAA2C;;IAE3C,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,oBAAoB;IACpB,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;IACtB,2BAA2B;;IAE3B,2BAA2B;IAC3B,0BAA0B;IAC1B,0BAA0B;IAC1B,yBAAyB;IACzB,4BAA4B;IAC5B,yBAAyB;IACzB,2BAA2B;IAC3B,gCAAgC;;IAEhC,wBAAwB;AAC5B","sourcesContent":[":root {\n    --arc-purple: #632582;\n    --header2-color: #04146a;\n    --highlight-block-color: #5A729F;\n    --border-blue: #add8e6;\n    --contrast-blue: #ECF6FD;\n    --filter-panel-grey: #F2F2F2;\n    --arc-pink: #b40156;\n    --anchor-visited: #632582;\n    --filter-font-color: #605F5E;\n    --arc-border-color: #c4c0c0;\n    --arc-approved-color: #216C06;\n    --arc-new-color: #6309e0;\n    --arc-held-color: #f3a508;\n    --arc-rejected-color: #8d0404;\n\n    --wieldy-nav-background-color: #036 ;\n    --wieldy-nav-highlight-orange: #fa8c16 ;\n    --wieldy-nav-highlight-light-blue: #038fde ;\n\n    --s360-orange: #ffe6cc;\n    --s360-red: #ffcccc;\n    --s360-yellow: #ffffcc;\n    --s360-green: #d6f5d6;\n    --s360-aqua: #e6ffff;\n    --s360-blue: #99b9cd;\n    --s360-purple: #f2ccff;\n    --s360-pink: #ffe6ff;\n    --s360-grey: #c7c7c7 ;\n    --s360-black: #0a0a0a ;\n    --s360-dialog-grey: #c7c7c7;\n\n    --s360-icon-green: #4caf50 ;\n    --s360-icon-gold: #ffcf40 ;\n    --s360-icon-blue: #4c98c9 ;\n    --s360-icon-red: #ad4f4f ;\n    --s360-icon-orange: #FF9800 ;\n    --s360-icon-pink: #d84bf3;\n    --s360-icon-purple: #767db2;\n    --s360-icon-unassigned: #d1d2d2 ;\n\n    --s360-bgcolor: #e4ffdc ;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
